// TD-23 — "YÜKLENEMEDİ" İLE "BOŞ"U AYIRAN TEK YER.
//
// services/api.js interceptor'ı OKUMALARDA (GET) ASLA reject ETMEZ: ağ hatası, 401, 403,
// 500 — hepsi `{ data: { status: false, data: null } }` ile RESOLVE olur (bkz. o dosyadaki
// EMPTY_RESPONSE ve "Reads → resolve empty" yorumu). Bunun iki sonucu var:
//
//   1. `.catch()` bloğu HİÇ ÇALIŞMAZ. Hook'ların `catch(() => setData([]))` dalları ölü
//      koddur; başarısızlıkta `.then()` çalışır ve `res.data?.data` undefined olur.
//   2. Dolayısıyla `const items = result?.data || []` yazan her hook, başarısız bir
//      okumayı BOŞ LİSTE olarak gösterir — ekran "kayıt yok" der, kullanıcı verinin
//      var olduğunu bilmez, hiçbir hata mesajı görmez.
//
// GERÇEK SİNYAL `res.data.status`'tur. Bu yardımcı onu okur ve çağırana "yüklendi mi"
// bilgisini `ok` olarak verir; hook'lar bunu `loadFailed` durumuna çevirir, ekranlar da
// boş-durum yerine hata bandı gösterir.
//
// NOT: interceptor başarısız GET'te hata ANAHTARINI da düşürür (EMPTY_RESPONSE'ta
// `message` yoktur) — bu yüzden ayrım tek bir boolean'dır, neden ayrıştırılmaz.
// `passErrorBody: true` geçen çağrılarda gövde korunur; o durumda `status` yine
// false'tur, yani bu yardımcı orada da doğru çalışır.

/** Okuma başarılı mı? Tek doğru sinyal: gövdedeki `status` alanı. */
export const isOk = (res) => res?.data?.status === true;

/**
 * Sayfalı VEYA düz liste yanıtını normalize eder.
 * Dönen `items` başarısız okumada HER ZAMAN boştur — ama `ok:false` ile birlikte,
 * yani çağıran ikisini karıştıramaz.
 */
export const readPage = (res) => {
  const ok = isOk(res);
  const result = res?.data?.data;
  const items = Array.isArray(result) ? result : (result?.data || []);
  return {
    ok,
    items: ok ? items : [],
    pagination: {
      totalRowCount: result?.totalRowCount ?? items.length,
      pageIndex: result?.pageIndex ? result.pageIndex - 1 : 0,
      pageSize: result?.pageSize || items.length || 10,
    },
  };
};

/** Tekil kayıt okuması: başarısızlıkta `undefined` DEĞİL, açıkça null. */
export const readItem = (res) => (isOk(res) ? (res.data?.data ?? null) : null);
